import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.oms')
  .filter('omsPackagesTotalCount', omsPackagesTotalCount);

function omsPackagesTotalCount($translate) {
  return function omsPackagesTotalCountFilter(packageRef, enableSuffix: boolean) {

    if (!packageRef) {
      return '--';
    }

    let totalPackages;

    totalPackages = _.reduce(packageRef, (sum, p) => {
      sum += p.count;
      return sum;
    }, 0);

    return enableSuffix ? $translate.instant(totalPackages == 1 ? 'X_PACKAGE' : 'X_PACKAGES', {sum: totalPackages}) : totalPackages;
  };
}
